import update from 'immutability-helper';
import * as types from './types';

export const initialState = {
  drillDown: false,
  syncedAutoRefreshState: true,
};

const networkRequest = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_DRILL_DOWN_STATE: {
      const { drillDown } = action;
      return update(state, {
        drillDown: {
          $set: drillDown,
        },
      });
    }

    case types.SET_SYNCED_AUTO_REFRESH_STATE: {
      const { syncedAutoRefreshState } = action;
      return update(state, {
        syncedAutoRefreshState: {
          $set: syncedAutoRefreshState,
        },
      });
    }

    default:
      return state;
  }
};

export default networkRequest;
